import React from "react";
import {
  IonButton,
  IonCardContent,
  IonSegment,
  IonSegmentButton,
  useIonAlert
} from "@ionic/react";
import "../../../styles/UserSignInComponent.css";
import { handleRequestOtpClick } from "../handler";

import { useRecoilState, } from "recoil";
import { userInput } from "../../../store/atoms/userDetailAtom";
import { handleUserInput } from "../handler"

function UserMobileOrEmailInput(props) {
  const [present] = useIonAlert()
  const [userInputState, setUserInputState] = useRecoilState(userInput);

  return (
    <>
      <IonCardContent>
        <IonSegment value={userInputState.userSelectedInput} role="tablist" class="md" >
          <IonSegmentButton value="mobileNumber" onClick={e => handleUserInput(setUserInputState, e.target.value, 'userSelectedInput' )}>Mobile</IonSegmentButton>
          <IonSegmentButton value="email" onClick={e =>  handleUserInput(setUserInputState, e.target.value,'userSelectedInput' )}>Email</IonSegmentButton>
        </IonSegment>
        <div className="custom-label">
          <ion-label>{userInputState.userSelectedInput === 'mobileNumber' ? "Mobile Number" : "Email"}</ion-label>
          <input type={userInputState.userSelectedInput === 'mobileNumber' ? "number" : "text"} className="custom-input" 
          value={userInputState.userSelectedInput === 'mobileNumber' ? userInputState.mobileNumber : userInputState.email}
          onChange={e => handleUserInput(setUserInputState, e.target.value, userInputState.userSelectedInput )} />
        </div>

        <IonButton
          color="primary"
          size="large"
          expand="block"
          mode="ios"
          onClick={async () => {
            let response = await handleRequestOtpClick(userInputState, props.setDisplayOtpVerification, setUserInputState);
            if(!response.status) {
              present({
                message: response.errorMessage,
                buttons: [
                        'Ok'
                ],
            })
            }
          }}
        >
          Request OTP
        </IonButton>

        <a href="/new/signup" className="link-btn">
          Sign up
        </a>
      </IonCardContent>
    </>
  );
}

export default UserMobileOrEmailInput;
